export const getAPIEndpoint = () => {
  if (typeof window !== 'undefined') {
    switch (window.location.hostname) {
      case 'localhost':
        return 'http://localhost:57761' //'http://localhost:57761'
      case 'paymentsdev.cure.com':
        return 'http://localhost:57761' //'http://localhost:57761'
      case 'paymentsstg.cure.com':
        return 'https://svcstg.cure.com' //'http://localhost:57761'
      case 'paymentsprep.cure.com':
        return 'https://svcprep.cure.com' //'http://localhost:57761'
      case 'payments.cure.com':
        return 'https://svc.cure.com' //'http://localhost:57761'
      default:
        return 'https://svcstg.cure.com'
    }
  }
}

export const getSiteEnv = (GetEnvironmentSettings = () => { }) => {
  if (typeof window !== 'undefined') {
    if (window.location.hostname == "payments.cure.com" || window.location.hostname != "localhost") {
      return 'prod'
    }
    var env = GetEnvironmentSettings('paymentsstg.cure.com');
    return env.GWApiEnv;
  }
}

export const getSiteEnvironment = () => {
  if (typeof window !== 'undefined') {
    switch (window.location.hostname) {
      case 'paymentsprep.cure.com':
        return 'Prepublish'
      case 'payments.cure.com':
        return 'Production'
      default:
        return 'Staging'
    }
  }
}

export const getRedirectEnv = () => {
  if (typeof window !== 'undefined') {
    console.log(window.location.hostname);
    switch (window.location.hostname) {
      case 'localhost':
        return ''
      case 'paymentsdev.cure.com':
        return 'myaccountdev.cure.com'
      case 'paymentsstg.cure.com':
        return 'myaccountstg.cure.com'
      case 'paymentsprep.cure.com':
        return 'myaccountprep.cure.com'
      case 'payments.cure.com':
        return 'myaccount.cure.com'
      default:
        return ''
    }
  }
}

export const getDomainQuote = () => {
  if (typeof window !== 'undefined') {
    switch (window.location.hostname) {
      case 'localhost':
        return 'getquotestg.cure.com'
      case 'paymentsdev.cure.com':
        return 'getquotedev.cure.com'
      case 'paymentsstg.cure.com':
        return 'getquotestg.cure.com'
      case 'paymentsprep.cure.com':
        return 'getquoteprep.cure.com'
      case 'payments.cure.com':
        return 'getquote.cure.com'
      default:
        return window.location.hostname
        break;
    }
  }
}

export const getDomainChat = () => {
  if (typeof window !== 'undefined') {
    switch (window.location.hostname) {
      case 'localhost':
        return 'chatstg.cure.com'
      case 'paymentsdev.cure.com':
        return 'chatdev.cure.com'
      case 'paymentsstg.cure.com':
        return 'chatstg.cure.com'
      case 'paymentsprep.cure.com':
        return 'chatprep.cure.com'
      case 'payments.cure.com':
        return 'chat.cure.com'
      default:
        return window.location.hostname
        break;
    }
  }
}


export const getDomain = () => {
  if (typeof window !== 'undefined') {
    switch (window.location.hostname) {
      case 'localhost':
        return 'https://staging.cure.com' //http://localhost:57761
      case 'paymentsdev.cure.com':
        return 'https://dev.cure.com'
      case 'paymentsstg.cure.com':
        return 'https://staging.cure.com'
      case 'paymentsprep.cure.com':
        return 'https://prepublish.cure.com'
      default:
        return 'https://www.cure.com'
    }
  }
}

export const getTestingEnvToken = () => {
  if (typeof window !== 'undefined') {
    return "44874035-568c-4db4-aed0-69a0a3203cd6";
  } else {
    return "";
  }
}